import * as datatableModule from '../../../shared/location/claim/datatable.js';

function FacebookMatchLocation($http, $stateParams, pmtAlertService) {
	let $ctrl = this;
	$ctrl.isPending = false;
	$ctrl.siteName = $stateParams.site;
	$ctrl.locations = null;

	function alert_(error) {
		if (error?.data?.type) {
			error = error.data;
		}
		pmtAlertService.alert({
			title: error.type || 'Error',
			body: error.message,
			confirmTitle: 'Ok',
			confirm: function () {
				pmtAlertService.close();
			}
		});
	}

	function setupDataTable(data) {
		$ctrl.datatable = datatableModule.init({
			data,
			element: '.fb-similar-locations',
			includeFbStoreId: true,
			actions: [
				{
					id: '1',
					text: 'Connect with Facebook data',
					onClick: item => {
						console.log('Selected: ', item.name, item.storeId);
						$http
							.post(
								`api/${$ctrl.siteName}/facebook/claim/notmatchedlocations/connecttofb/${$ctrl.unmatchedId}/${item._id}`
							)
							.then(() => {
								alert_({
									type: 'Connect succeeded',
									message: `
Connect
<a href="${item.link}" target="_blank">${item.name}</a>(#${item.storeId})
to
<a href="${$ctrl.unmatchedLocation.link}" target="_blank">${$ctrl.unmatchedLocation.name}</a>(#${$ctrl.unmatchedLocation.storeId})
successfully.
									`
								});
							}, alert_);
					}
				},
				{
					id: '2',
					text: 'Connect with PinMeTo data',
					onClick: item => {
						console.log('Selected: ', item.name, item.storeId);
						$http
							.post(
								`api/${$ctrl.siteName}/facebook/claim/notmatchedlocations/connecttopmt/${$ctrl.unmatchedId}/${item._id}`
							)
							.then(() => {
								alert_({
									type: 'Connect succeeded',
									message: `
Connect
<a href="${item.link}" target="_blank">${item.name}</a>(#${item.storeId})
to
<a href="${$ctrl.unmatchedLocation.link}" target="_blank">${$ctrl.unmatchedLocation.name}</a>(#${$ctrl.unmatchedLocation.storeId})
successfully. To perform the connection, you need to run location finder.
									`
								});
							}, alert_);
					}
				}
			]
		});
		$ctrl.download = () =>
			$ctrl.datatable.downloadAsCsv(`Similar_Locations_of_${$ctrl.unmatchedLocation.storeId}.csv`);
	}

	const getSimilarPages = () => {
		$ctrl.isPending = true;
		$http
			.get(`api/${$ctrl.siteName}/facebook/claim/notmatchedlocations/similar/${$ctrl.unmatchedId}`)
			.then(result => {
				result.data.forEach(n => {
					n.link = `${window.location.origin}/listings/${$ctrl.siteName}/locations/${n._id}/details`;
				});
				$ctrl.locations = result.data;
				$ctrl.locations.forEach(n => {
					n.fbStoreId = n.fb?.storeId || $ctrl.unmatchedLocation.storeId || n.storeId;
				});
				setupDataTable($ctrl.locations);
				$ctrl.isPending = false;
			}, alert_);
	};
	$ctrl.$onChanges = changes => {
		const v = changes?.unmatchedLocation?.currentValue;
		if (v) {
			$ctrl.unmatchedLocation = v;
			$ctrl.unmatchedId = v._id;
			getSimilarPages();
		} else {
			$ctrl.locations = null;
		}
	};
}

FacebookMatchLocation.$inject = ['$http', '$stateParams', 'pmtAlertService'];
angular.module('pmtPlacesApp.directives').component('pmtFacebookMatchLocation', {
	templateUrl: 'components/claim/facebook/pmtFacebookMatchLocation.html',
	controller: FacebookMatchLocation,
	bindings: {
		unmatchedLocation: '<'
	}
});
